import { render, staticRenderFns } from "./SpaceCurtain.vue?vue&type=template&id=625ffebb&scoped=true"
import script from "./SpaceCurtain.vue?vue&type=script&lang=js"
export * from "./SpaceCurtain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ffebb",
  null
  
)

export default component.exports